import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SkeletonShape, SkeletonSize } from '../../../types/skeleton.type';

const DEFAULT_SKELETON_HEIGHT_PX = 16;

/**
 * A pulsing placeholder bar shown in place of content that is still loading. With `lineHeight`
 * the host takes the text line's height and centres the bar in it, so a skeleton line sits
 * exactly where the text it stands for will be.
 */
@Component({
  selector: 'fr8bot-ui-skeleton',
  templateUrl: './skeleton.component.html',
  host: {
    class: 'tw:flex tw:shrink-0 tw:items-center',
    'aria-hidden': 'true',
    '[style.width]': 'cssWidth()',
    '[style.height]': 'cssLineHeight()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonUIComponent {
  readonly width = input<SkeletonSize>('100%');
  readonly height = input<SkeletonSize>(DEFAULT_SKELETON_HEIGHT_PX);
  readonly lineHeight = input<SkeletonSize | null>(null);
  readonly shape = input<SkeletonShape>('rect');

  readonly cssWidth = computed(() => toCssSize(this.width()));
  readonly cssHeight = computed(() => toCssSize(this.height()));
  readonly cssLineHeight = computed(() => toCssSize(this.lineHeight() ?? this.height()));
}

function toCssSize(size: SkeletonSize): string {
  return typeof size === 'number' ? `${size}px` : size;
}
